import { createTheme } from "@mui/material/styles";
// #FAF8C0 - yellow
// #BFECFF - blue
// #C7BFFF - purple
const theme = createTheme({
  palette: {
    mode: "light",
    background: {
      default: "#fff",
      paper: "#fff",
    },
    text: {
      //primary: "#fff",
      //secondary: "rgba(255,255,255,0.8)",
    },
    primary: {
      main: "#1bbc9e",
    },
    secondary: {
      main: "#fcf87e",
    },
  },
  typography: {
    fontFamily: '"Montserrat",  sans-serif',
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        caption: {
          color: "rgba(255,255,255,0.6)",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 700,
          color:"#444",
          background:"#e8e8e8",
        },
        body: {
          borderBottom: "1px solid rgba(0,0,0,0.1)",
        },
      },
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          "& a": {
            textDecoration: "none",
          },
        },
      },
    },
    MuiStepButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
        },
      }
    },
    MuiStepLabel: {
      styleOverrides: {
        label: {
          "&.Mui-active p": {
            fontWeight: 700
          }
        },
      }
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          color: "#FAF8C0",
        },
        text: {
          fontWeight: 600
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundImage: "none"
        }
      }
    }
  },
});

export default theme;
